<template>
  <v-data-table
    :items="exames"
    :headers="headersExame"
    v-model="selected"
    show-select
    :footer-props="{
      'items-per-page-options': [10, 25, 50, -1]
    }"
  >
    <template v-slot:[`top`]>
      <v-btn :disabled="!downloadable" :dark="downloadable" elevation="0" class="rounded-lg ma-1" color="primary" :loading="loading" @click="downloadAll">
        Visualizar todos os selecionados
      </v-btn>
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <v-chip small class="font-weight-bold" :color="item.status === 'Liberado' ? 'green lighten-2' : 'blue-grey lighten-4'">
        {{item.status || "Status desconhecido"}}
      </v-chip>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <BtnDownload :exame="item" />
    </template>
  </v-data-table>
</template>

<script>
import { api } from '@/api'
import BtnDownload from '@/components/BtnDownload'

function base64ToArrayBuffer (data) {
  const bString = window.atob(data)
  const bLength = bString.length
  const bytes = new Uint8Array(bLength)
  for (let i = 0; i < bLength; i++) {
    const ascii = bString.charCodeAt(i)
    bytes[i] = ascii
  }
  return bytes
};

export default {

  components: {
    BtnDownload
  },

  props: {
    exames: {
      type: Array,
      default: () => []
    },
    print: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      selected: [],
      loading: false
    }
  },

  methods: {
    async downloadAll () {
      console.log(this.selected)
      this.loading = true
      try {
        const response = await api.post('/report/generate-many', this.selected.map(exame => exame.reportParams))

        console.log(response.data)

        const bufferArray = base64ToArrayBuffer(response.data.base64string)
        const blobStore = new Blob([bufferArray], { type: 'application/pdf' })

        const data = window.URL.createObjectURL(blobStore)

        const pdfWindow = window.open(data)
        if (this.print) {
          pdfWindow.print()
        }

        // window.URL.revokeObjectURL(data)
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
        this.selected = []
      }
    }
  },

  computed: {
    downloadable () {
      return Boolean(this.selected.length) && this.selected.every(exame => exame.status === 'Liberado')
    },
    headersExame () {
      return [
        {
          text: 'Exame',
          value: 'name'
        },
        {
          text: 'Data',
          value: 'date'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          text: 'Ações',
          value: 'actions'
        }
      ]
    }
  }

}
</script>

<style>

</style>
